import { render } from "./StepThree.vue?vue&type=template&id=7c0f0a6e&scoped=true"
import script from "./StepThree.vue?vue&type=script&lang=js"
export * from "./StepThree.vue?vue&type=script&lang=js"

import "./StepThree.vue?vue&type=style&index=0&id=7c0f0a6e&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/sb.web.app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c0f0a6e"]])

export default __exports__